import React, { useContext } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Button } from 'antd';
import { LocaleContext } from 'utils/OwnIntlProvider';
import Logo from 'Common/Components/Logo';
import { ScreenWrapper } from './Login';
import ForgotPasswordContainer from '../components/ForgotPassword';
import FormWrapper from '../components/views/FormWrapper';
import SupportText from '../components/views/SupportText';

const Title = styled.span`
  font-size: 24px;
  font-weight: 500;
  color: ${(props) => props.theme.gray1};
  padding: 8px 0 16px;
  margin-right: auto;
`;

export const SignInButton = styled(Button)`
  display: block !important;
  margin: 8px auto 0 !important;
  padding: 0 !important;
  height: auto !important;
  font-size: 13px !important;
  color: ${(props) => props.theme.gray} !important;
`;

const ForgotPassword = () => {
  const context = useContext(LocaleContext);

  const switchLanguage = (lng: string) => {
    localStorage.setItem('locale', lng);
    context.selectLanguage(lng);
  };

  return (
    <ScreenWrapper>
      <FormWrapper>
        <Logo padding="16px" />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '38px',
            width: '100%',
          }}
        >
          <Title>
            <FormattedMessage defaultMessage="Forgot your password?" />
          </Title>
          <ForgotPasswordContainer />
          <div css="text-align: center; margin-top: 8px;margin-bottom: 25px;">
            <SignInButton type="link" href="/login" css="padding: 0;">
              <FormattedMessage defaultMessage="Go back to sign in" />
            </SignInButton>
          </div>
        </div>
        <SupportText
          selectedLang={context.locale}
          changeLang={switchLanguage}
        />
      </FormWrapper>
    </ScreenWrapper>
  );
};

export default ForgotPassword;
